export const ProjectStatuses = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  DELETED: 'deleted',
  INACTIVE: 'inactive',
  INVITED: 'invited',
  PENDING: 'pending',
  SUSPENDED: 'suspended',
  ACTIVATING: 'activating',
  DEACTIVATING: 'deactivating',
  ACTIVATION_FAILED: 'activationFailed',
  DEACTIVATION_FAILED: 'deactivationFailed'
};
